// EU country codes
const EU_COUNTRIES = new Set([
  'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU',
  'IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES',
  'SE','GB','NO','CH','IS','LI','AL','BA','ME','MK','RS','TR','UA','MA'
]);

const US_BOUNDS = {
  minLat: 24.5, maxLat: 49.5,
  minLng: -125.0, maxLng: -66.0
};

function isInUS(lat, lng) {
  return lat >= US_BOUNDS.minLat && lat <= US_BOUNDS.maxLat &&
         lng >= US_BOUNDS.minLng && lng <= US_BOUNDS.maxLng;
}

export async function getMyCountry() {
  try {
    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();
    return data.country_code || 'UNKNOWN';
  } catch {
    return 'UNKNOWN';
  }
}

export function filterByGeoRestriction(users, myCountry) {
  if (!myCountry || myCountry === 'UNKNOWN') return users;
  const iAmInEU = EU_COUNTRIES.has(myCountry);
  const iAmInUS = myCountry === 'US';

  return users.filter(u => {
    if (!u.lat || !u.lng) return true;
    const userInUS = isInUS(u.lat, u.lng);

    // US profiles only visible to EU users
    if (userInUS) return iAmInEU || iAmInUS;

    // All other profiles visible to everyone
    return true;
  });
}
